// export enum ProcessCodeEnum {
//   card = 1 /* כרטיס אשראי */,
//   loan = 2 /* הלוואה לפרטיים */,
//   employer = 3 /* כרטיס מעסיק */,
//   upsell = 4 /* מסגרת אפס */,
//   bnpl = 5 /* הלוואה קנה עכשיו שלם אחר כך */
// }

// export enum ProcessIdEnum {
//   card = 'card' /* כרטיס אשראי */,
//   loan = 'loan' /* הלוואה לפרטיים */,
//   employer = 'employer' /* כרטיס מעסיק */,
//   upsell = 'upsell' /* מסגרת אפס */,
//   bnpl = 'bnpl' /* הלוואה קנה עכשיו שלם אחר כך */
// }

export enum CustomerStatusEnum {
  none = null,
  new = 1,
  existent = 2
}
export enum AccountStatusEnum {
  none = null,
  new = 1,
  existent = 2
}

export enum InterestTypeEnum {
  variable = 0,
  fixed = 1,
  fixedLinked = 2
}

export enum MaritalStatusEnum {
  married = 1,
  single = 0
}

export enum LeadStatusEnum {
  notInterested = 0,
  interested = 1
}

export enum SingleBeneficiaryEnum {
  yes = 3,
  no = 2
}

export enum CountryEnum {
  israel = 0,
  abroad = 1
}

export enum ChannelStatusEnum {
  accepted = 3,
  rejected = 1
}
export enum CreditAgreementStatusEnum {
  approve = 1,
  decline = 2,
  indication = 3
}

export enum LanguageEnum {
  Hebrew = 1,
  Arabic = 2,
  Russian = 3,
  Amharic = 4,
  French = 5,
  English = 6
}

export enum BeneficiariesOptionEnum {
  SpecificBeneficiaries = 1,
  UnknownBeneficiaries = 2,
  CommunalAccount = 3,
  OwnerManagedAccount = 4,
  LimitedCreditAccount = 5,
  StateManagedAccount = 6,
  DelegateManagedAccount = 7
}

export enum CreditAgreementExpirationYearsPeriodEnum {
  extendedPeriod = 100,
  defaultPeriod = 10
}

export const ClubMembershipConfig = {
  options: {
    mandatory: [2, 4],
    visible: [1, 2, 3, 4],
    postEligibility: [3, 4]
  },
  '0': {
    default: true,
    value: 0,
    mandatory: false,
    visible: false,
    description: "לא נדרש מס' חבר מועדון"
  },
  '1': {
    value: 1,
    mandatory: false,
    visible: true,
    description: 'השדה יוצג ויהיה רשות'
  },
  '2': {
    value: 2,
    mandatory: true,
    visible: true,
    description: 'השדה יוצג ויהיה חובה'
  },
  '3': {
    value: 3,
    mandatory: false,
    visible: false,
    description: 'השדה יוצג רק לאחר קבלת שגיאה מבדיקת זכאות (לפי השגיאות הקיימות) ויהיה רשות'
  },
  '4': {
    value: 4,
    mandatory: true,
    visible: false,
    description: 'השדה יוצג רק לאחר קבלת שגיאה מבדיקת זכאות (לפי השגיאות הקיימות) ויהיה חובה'
  }
} as const;
